import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";


import { addMessage, setHistory, removeBookmark, setBookmarks } from "../store/appSlices";
import {
    //  userQuery, 
    // chatHistory,
    // userFeedback, 
    mdToPDF,
    // getBookmarks, 
    updateAPIKey, apiKeyDetails, bookmarkSearch,
    // contactUsSubmission,
    // registeredUserContactSubmission,
    // getRegisteredUserContactSubmissions
} from "../services/api";

import { userQuery, chatHistory, getBookmarks, userFeedback, registeredUserContactSubmission, getRegisteredUserContactSubmissions, contactUsSubmission } from "../services/userService";

export const useGetRegisteredUserContactSubmissions = () => {
    return useQuery({
        queryKey: ["registeredUserContactSubmissions"],
        queryFn: getRegisteredUserContactSubmissions,
    });
};

// export const useGetRegisteredUserContactSubmissions = () => {
//     return useMutation({
//         mutationFn: getRegisteredUserContactSubmissions,
//         onSuccess: (data) => {
//             console.log(data);
//         },
//         onError: (error) => {
//             console.log(error);
//         }
//     });
// };

export const useRegisteredUserContactSubmission = ({ onSuccess, onFailure }) => {
    return useMutation({
        mutationFn: registeredUserContactSubmission,
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if (onFailure) onFailure(error);
        }
    });
};

export const useContactUsSubmission = ({ onSuccess, onFailure }) => {
    return useMutation({
        mutationFn: contactUsSubmission,
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if (onFailure) onFailure(error);
        }
    });
};

export const useBookmarkSearch = () => {
    return useMutation({
        mutationFn: bookmarkSearch,
    });
};

export const useApiKeyDetails = () => {
    return useMutation({
        mutationFn: apiKeyDetails,
    });
};

export const useChangeApiKey = (onSuccessCallback) => {
    // const { storeAuthData, clearAuthData } = useAuth();
    return useMutation({
        mutationFn: updateAPIKey,
        onSuccess: (data) => {
            // Execute the success callback (if provided)
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        },
    });
};

export const useGetBookmarks = () => {
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: getBookmarks,
        onSuccess: (data) => {
            dispatch(setBookmarks(data));
        }
    });
};

export const useUserFeedback = () => {
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: userFeedback,
        onSuccess: (data) => {
            if (data.submit_type === "bookmark" && !data.submit_value) {
                const contentID = data.content_id;
                // remove that particular entry from bookmarks slice
                dispatch(removeBookmark(contentID));
            }
        }
    });
};


export const useUserQuery = (onSuccessCallback) => {
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: userQuery,
        onSuccess: (data) => {
            // console.log("data", data);
            dispatch(addMessage(data));
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        }
    });
};


export const useMdToPDF = () => {
    return useMutation({
        mutationFn: mdToPDF,
    });
};

export const useChatHistory = () => {
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: chatHistory,
        onSuccess: (data) => {
            // console.log(data);
            dispatch(setHistory(data));
        }
    });
};
